








import Component from 'vue-class-component';
import ConfigUtils from '@/utils/config.utils';
import Vue from 'vue';

@Component({
})
export default class App extends Vue {
  mounted() {
    document.title = ConfigUtils.getPageTitle() || 'TAFT';
  }
}
